import type {IVStoreState} from '../useIVStore.ts';

export const getOCRPassed = (state: IVStoreState) => state.ocrResultData.ocrPassed;
